export type Dimension = {width: number, height: number};

export class RescaleSvc {

    static resizeWithAspectRatio(w: number, h: number, maxWidth: number, maxHeight?: number, round = true, upscale = false): Dimension {
        let ratio: number,
            width = w,
            height = h,
            newDimension = {
                width: w,
                height: h
            };
        if (upscale) {
            width  = width * 9999;
            height = height * 9999;
        }

        if (width > maxWidth) {
            ratio = maxWidth / width;
            newDimension.width = maxWidth;
            newDimension.height = height * ratio;
            height = height * ratio;
            width = width * ratio;
        }

        if (height > maxHeight) {
            ratio = maxHeight / height;
            newDimension.height = maxHeight;
            newDimension.width = width * ratio;
        }
        if (round) {
            Object.keys(newDimension).forEach(k => newDimension[k] = Math.round(newDimension[k]));
        }
        return newDimension;
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/RescaleSvc.ts